// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { railStyle, trackStyle, handleStyle, StyledRcSlider } from './Slider.styles';

const StyledRange = StyledRcSlider;

function Slider(props) {
  const { defaultRangeValue, defaultSlideValue, isRange, disabled = false } = props;

  return (
    <div style={{ width: '100%', padding: '2px 9px' }}>
      {isRange ? (
        <StyledRange
          defaultRangeValue={defaultRangeValue}
          defaultSlideValue={defaultSlideValue}
          isRange={isRange}
          disabled={disabled}
          range={isRange}
          allowCross={false}
          defaultValue={defaultRangeValue}
          handleStyle={disabled ? handleStyle.disabled : handleStyle.default}
          railStyle={disabled ? railStyle.disabled : railStyle.default}
          style={{ background: 'transparent' }}
          trackStyle={disabled ? trackStyle.disabled : trackStyle.default}
        />
      ) : (
        <StyledRcSlider
          defaultRangeValue={defaultRangeValue}
          defaultSlideValue={defaultSlideValue}
          isRange={isRange}
          disabled={disabled}
          defaultValue={defaultSlideValue}
          handleStyle={disabled ? handleStyle.disabled : handleStyle.default}
          railStyle={disabled ? railStyle.disabled : railStyle.default}
          style={{ background: 'transparent' }}
          trackStyle={disabled ? trackStyle.disabled : trackStyle.default}
        />
      )}
    </div>
  );
}

Slider.propTypes = {
  /**
   * Sets the range handles at the given values when rendering a range slider
   */
  defaultRangeValue: PropTypes.arrayOf(PropTypes.number),
  /**
   * Sets the slider handle at the given value when rendering a basic slider
   */
  defaultSlideValue: PropTypes.number,
  /**
   * If true, it renders a range slider
   */
  isRange: PropTypes.bool,

  disabled: PropTypes.bool
};

Slider.defaultProps = {
  defaultRangeValue: [0, 0],
  defaultSlideValue: undefined,
  isRange: false,
  disabled: false
};

export default Slider;
